import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FormsModule } from '@angular/forms';
import { inject } from '@angular/core';
import { AgendaService } from '../../../services/aganda-service/agenda.service';
import { Agenda } from '../../_models/AgendaDTO';
import { useAnimation } from '@angular/animations';
import { DialogService } from '../../_modal/dialog.service';
import { SampleService } from '../../../services/sample-service/sample.service';
import { MatDialog } from '@angular/material/dialog';
import { MatCard } from "@angular/material/card";

@Component({
  selector: 'app-bench-sheet',
  standalone: true,
  imports: [CommonModule, FullCalendarModule, FormsModule, MatCard],
  templateUrl: './bench-sheet.component.html',
  styleUrls: ['./bench-sheet.component.scss']
})
export class BenchSheetComponent implements OnInit{
  private agendaService = inject(AgendaService);
  @ViewChild('taskDetailModal') taskDetailModal!: TemplateRef<any>;

  selectedTask: Agenda | null = null;
  events: any[] = [];

  calendarOptions: CalendarOptions;
  showForm = false;
  formData = {
    title: '',
    start: '',
    end: '',
    taskTypeId: null,
    sampleId: null
  };
  
  taskTypes: { id: number; label: string }[] = [];
  samples: { id: number; sampleCode: string }[] = [];
  
  showSampleSelect = false;

  constructor(    private dialogService: DialogService,
    private sampleService: SampleService,
    private dialog: MatDialog ) {
    this.calendarOptions = {
      initialView: 'dayGridMonth',
      locale:'fr',
        buttonText: {
    today:    'Aujourd\'hui',
    month:    'Mois',
    week:     'Semaine',
    day:      'Jour',
    list:     'Liste'
  },

  dayHeaderFormat: { weekday: 'long' },  // Jours en toutes lettres

  titleFormat: { // Format du titre en haut du calendrier
    year: 'numeric',
    month: 'long',
  },
      editable: true,
      selectable: true,
      plugins: [dayGridPlugin, interactionPlugin],
      events: this.events,
      dateClick: this.handleDateClick.bind(this),
      eventClick: this.handleEventClick.bind(this),
    };
   this.loadEventsFromBackend();
  }
  
  openTaskDetailModal(id: number) {
    this.agendaService.getAgendaById(id).subscribe(task => {
      console.log("📄 Détails récupérés :", task); // <= ✅ Console ici
      this.selectedTask = task;
      this.dialog.open(this.taskDetailModal, {
        width: '520px'
      });
    }, error => {
      console.error('Erreur récupération tâche:', error);
      this.dialogService.openDangerAlert('Erreur lors de la récupération des détails.');
    });
  }
  
 confirmDeleteTask(id: number | undefined) {
  if (id === undefined) {
    console.warn("❌ Impossible de supprimer : id indéfini.");
    return;
  }

  // 🟢 Étape 1 : fermer le dialog de détails avant d'afficher la confirmation
  this.dialog.closeAll();

  // 🕒 Étape 2 : petit délai avant d’ouvrir la confirmation
  setTimeout(() => {
    this.dialogService.confirm('Voulez-vous vraiment supprimer cette tâche ?').then(confirmed => {
      if (confirmed) {
        this.agendaService.deleteAgenda(id).subscribe({
          next: () => {
            console.log(`✅ Tâche ${id} supprimée`);
            this.loadEventsFromBackend();
          },
          error: err => {
            console.error('❌ Erreur lors de la suppression :', err);
            this.dialogService.openDangerAlert('Échec de la suppression.');
          }
        });
      }
    });
  }, 200); // 200 ms suffisent pour fermer proprement la modale
}

  
  // Modifie ta méthode handleEventClick pour appeler openTaskDetailModal au lieu de confirmer suppression
  handleEventClick(arg: any) {
    const id = Number(arg.event.id);
    this.openTaskDetailModal(id);
  }

  // Méthode pour afficher le label du type de tâche
  getTaskTypeLabel(id?: number): string {
    if (!id) return 'N/A';
    const t = this.taskTypes.find(tt => tt.id === id);
    return t ? t.label : 'N/A';
  }

  // Méthode pour afficher le code échantillon
  getSampleCode(id?: number | null): string {
    if (!id) return 'N/A';
    const s = this.samples.find(sam => sam.id === id);
    return s ? s.sampleCode : 'N/A';
  }

  
  ngOnInit() {
    this.loadTaskTypes();
    this.loadSamples();
    this.loadEventsFromBackend();
  }
  
  loadTaskTypes() {
    this.sampleService.getTaskTypes().subscribe((types: { id: number; label: string; }[]) => {
      console.log('✅ Types de tâches chargés :', types);
      this.taskTypes = types;
    });
  }
  
  loadSamples() {
    this.sampleService.fetchSampleList().subscribe(response => {
      if (response.status) {
        this.samples = response.data;  // data contient bien la liste des samples
      } else {
        console.error('Erreur lors de la récupération des échantillons:', response.message);
        this.samples = [];
      }
    }, error => {
      console.error('Erreur HTTP lors de la récupération des échantillons', error);
      this.samples = [];
    });
  }
  
  // Appelé au changement du type de tâche
  onTaskTypeChange() {
    const selectedId = Number(this.formData.taskTypeId);
    console.log('🔁 ID sélectionné (number):', selectedId);
  
    const taskType = this.taskTypes.find(t => t.id === selectedId);
    console.log('🔍 taskType trouvé:', taskType);
  
    if (!taskType) {
      console.log('❌ Aucun taskType correspondant trouvé.');
      this.showSampleSelect = false;
      return;
    }
  
    console.log('✅ Label du taskType sélectionné :', taskType.label);
  
    const labelsQuiMontrentSamples = ['Preparation', 'Analyse'];
  
    this.showSampleSelect = labelsQuiMontrentSamples.includes(taskType.label);
    console.log('📦 Affichage des samples activé ?', this.showSampleSelect);
  
    if (!this.showSampleSelect) {
      console.log('🧹 Réinitialisation de sampleId (car non affiché)');
      this.formData.sampleId = null;
    }
  }
  
  
  loadEventsFromBackend() {
    this.agendaService.getAgendas().subscribe(data => {
      this.events = data.map(a => {
        const start = a.startDate;
        const end = new Date(a.endDate);
        end.setDate(end.getDate() + 1); // Inclure le jour de fin
  
        return {
          id: a.id,
          title: a.name,
          start: start,
          end: end.toISOString().split('T')[0], // format YYYY-MM-DD
          createdBy: a.createdBy
        };
      });
  
      this.calendarOptions.events = [...this.events];
    });
  }
  
  resetForm() {
    this.formData = {
      title: '',
      start: '',
      end: '',
      taskTypeId: null,
      sampleId: null
    };
    this.showSampleSelect = false;
    this.showForm = false; 

  }
  



  handleDateClick(arg: any) {
    this.formData.start = arg.dateStr;
    this.formData.end = arg.dateStr;
    this.showForm = true;
  }


submitForm() {
  const currentUser = sessionStorage.getItem('use_username') || 'inconnu';
  const userId = Number(sessionStorage.getItem('user_id'));

  console.log('📦 Données du formulaire :', this.formData);
  console.log('👤 Utilisateur courant :', currentUser);
  console.log('🆔 ID utilisateur :', userId);

  const newAgenda: Agenda = {
    name: this.formData.title,
    startDate: this.formData.start,
    endDate: this.formData.end,
    createdBy: currentUser,
    appUserId: userId,
    taskTypeId: this.formData.taskTypeId ?? undefined,  // ou null si tu préfères
    sampleId: this.formData.sampleId ?? null
  };
  
  console.log('📤 Données envoyées au backend :', newAgenda);

  this.agendaService.createAgenda(newAgenda).subscribe(saved => {
    console.log('✅ Réponse du backend :', saved);

    // 🔄 Recharge tous les événements depuis le backend
    this.loadEventsFromBackend();

    this.resetForm();
  }, error => {
    console.error('❌ Erreur lors de la création de l\'agenda :', error);
  });
}

}

